const socialAccountProviderTypes = {
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  LINKED_IN: 'LINKED_IN',
  TWITTER: 'TWITTER',
  YOUTUBE: 'YOUTUBE',
  TIKTOK: 'TIKTOK',
  REDDIT: 'REDDIT'
};

export default socialAccountProviderTypes;